import {
  Divider,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Tooltip,
  Typography,
} from '@material-ui/core';
import ProgressBar from 'components/__ASSESSOR__/ProgressBar/ProgressBar';
import { SyncIcon } from 'components/Icons';
import LayoutContext from 'components/Layout/LayoutContext';
import GenericModal, {
  IGenericModalProps,
} from 'components/Modal/__LEGACY__/GenericModal/GenericModal';
import { AssembleiaTipoPauta } from 'helpers/enums/AssembleiaPautaStatus';
import { getUniqueKey } from 'helpers/utils/KeyUtils';
import { languageValues } from 'helpers/utils/languageUtils';
import { toFixedPercentage } from 'helpers/utils/StringUtils';
import translation from 'locales/translation';
import { ToastTypes } from 'plataforma-fundacao-componentes';
import React, { useContext, useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { assembleiasAssociadoActionsLoadRespostaPauta } from 'store/modules/AssembleiasAssociadoActions';
import { modalsActionsClose } from 'store/modules/ModalsActions';
import { ModalsActionsClose } from 'store/modules/ModalsActionTypes';
import { IModalProps } from 'store/modules/ModalsReducer';
import { IReducer } from 'store/Reducer';
import useStyles from './style';

export interface IRespostaPautaModalProps extends IGenericModalProps {
  key: string;
  idPauta: number;
  isParcial: boolean;
  tipoPauta?: AssembleiaTipoPauta;
}

export interface IRespostaPautaModal extends IModalProps {
  genericProps: IRespostaPautaModalProps;
  modalsActionsClose: (key: string) => ModalsActionsClose;
}

const mapStateToProps = (state: IReducer) => {
  return {
    assembleias: state.assembleiasAssessor,
    usuario: state.auth.usuario,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) =>
  bindActionCreators(
    {
      modalsActionsClose,
    },
    dispatch
  );

const RespostaPautaModal = ({
  genericProps,
  open,
  modalsActionsClose,
}: IRespostaPautaModal) => {
  const assembleias = useSelector((state: IReducer) => state.assembleias);

  const dispatchAction = useDispatch();
  const classes = useStyles();
  const [flgMeusNucleos, setFlgMeusNucleos] = useState<number>(1);
  const toClose = (): void => {
    if (genericProps && genericProps.key) {
      dispatchAction(modalsActionsClose(genericProps.key));
    }
  };

  const { showToast } = useContext(LayoutContext);

  useEffect(() => {
    if (genericProps && genericProps.idPauta) {
      dispatchAction(
        assembleiasAssociadoActionsLoadRespostaPauta(
          genericProps.idPauta,
          () => {},
          (error) => {
            showToast({
              pauseOnFocusLoss: true,
              theme: ToastTypes.Error,
              showStatusBar: true,
              timeout: 4000,
              label: languageValues.toasts.error.keyErrors(
                error.message,
                translation.RespostaPautaModal.error
              ),
            });
          }
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatchAction, genericProps]);

  const getPercentNumber = (
    percent: number | string,
    presentes: number
  ): number => {
    if (presentes > 0 && typeof percent === 'number') {
      return toFixedPercentage(percent);
    }
    return 0;
  };

  const getContent = () => {
    if (genericProps && genericProps.idPauta) {
      return assembleias.respostaPauta?.agencias.map((it, index) => (
        <React.Fragment key={getUniqueKey()}>
          {it.nucleos
            .filter(
              (nucleoItens) =>
                (nucleoItens.associadoLogadoisConvocado && flgMeusNucleos) ||
                !flgMeusNucleos
            )
            .map((nucleoItens) => (
              <React.Fragment key={index}>
                <Grid container className={classes.itemContainer}>
                  <Grid
                    component={Typography}
                    item
                    xs={6}
                    sm={3}
                    className={[
                      classes.labelData,
                      classes.labelDataStrong,
                    ].join(' ')}
                  >
                    {translation.RespostaPautaModal.agenciaItem(
                      it.codigoAgencia
                    )}
                  </Grid>
                  <Grid
                    component={Typography}
                    item
                    xs={6}
                    sm={3}
                    className={[
                      classes.labelData,
                      classes.labelDataStrong,
                    ].join(' ')}
                  >
                    {translation.RespostaPautaModal.nucleoItem(
                      nucleoItens.numeroNucleo
                    )}
                  </Grid>
                  <Grid
                    component={Typography}
                    item
                    xs={12}
                    sm={6}
                    className={[
                      classes.labelData,
                      classes.labelDataStrong,
                    ].join(' ')}
                  >
                    {translation.RespostaPautaModal.totalPresentesItem(
                      nucleoItens.presentes
                    )}
                  </Grid>

                  {nucleoItens.itens
                    .sort((itemA, itemB) => {
                      if (itemA.abstencao) return 1;
                      if (itemB.abstencao) return -1;
                      return itemA.idItemPauta - itemB.idItemPauta;
                    })
                    .map((nucleoItem) => (
                      <React.Fragment key={getUniqueKey()}>
                        <Grid
                          component={Typography}
                          item
                          xs={6}
                          className={classes.labelData}
                        >
                          {nucleoItem.descricao}
                        </Grid>
                        <Grid
                          component={Typography}
                          item
                          xs={6}
                          className={classes.percentItem}
                        >
                          {getPercentNumber(
                            nucleoItem.percentual,
                            nucleoItens.presentes
                          )
                            .toString()
                            .replace('.', ',')}
                          %
                        </Grid>
                        <Grid item xs={12}>
                          <ProgressBar
                            genericProps={{
                              percent: getPercentNumber(
                                nucleoItem.percentual,
                                nucleoItens.presentes
                              ),
                            }}
                          />
                        </Grid>
                      </React.Fragment>
                    ))}
                </Grid>
                <Divider />
              </React.Fragment>
            ))}
        </React.Fragment>
      ));
    }
  };

  const getAgenciasTitle = () => {
    const codigos = assembleias.respostaPauta?.agencias.map(
      (item) => item.codigoAgencia
    );
    if (codigos) {
      return codigos.join(', ');
    }
    return '';
  };

  return (
    <GenericModal
      open={open ?? false}
      title={translation.RespostaPautaModal.title(getAgenciasTitle())}
      content={
        !assembleias.loadingRespostaPauta &&
        genericProps.idPauta === assembleias.respostaPauta?.idPauta ? (
          <React.Fragment>
            <Tooltip title={assembleias.respostaPauta?.titulo}>
              <Typography component='p' className={classes.pautaTitle}>
                {assembleias.respostaPauta?.titulo}
              </Typography>
            </Tooltip>
            {genericProps.tipoPauta !== AssembleiaTipoPauta.Coordenador && (
              <React.Fragment>
                <Divider />
                <Typography component='p' className={classes.presentResults}>
                  Apresentar os resultados:
                </Typography>
                <RadioGroup
                  value={flgMeusNucleos}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setFlgMeusNucleos(parseInt(e.target.value))
                  }
                  className={classes.radioGroup}
                >
                  <FormControlLabel
                    value={1}
                    checked={Boolean(flgMeusNucleos)}
                    control={<Radio color='primary' />}
                    label={translation.RespostaPautaModal.labelMeusNucleos}
                    labelPlacement='start'
                  />
                  <FormControlLabel
                    value={0}
                    checked={!Boolean(flgMeusNucleos)}
                    control={<Radio color='primary' />}
                    label={translation.RespostaPautaModal.labelTodosNucleos}
                    labelPlacement='start'
                  />
                </RadioGroup>
              </React.Fragment>
            )}
            <Divider />
            {getContent()}
            <Typography component='p'>
              {
                translation.RespostaPautaModal[
                  genericProps.isParcial ? 'resultadoParcial' : 'resultadoFinal'
                ]
              }
            </Typography>
          </React.Fragment>
        ) : (
          <Typography component='p' className={classes.loading}>
            <SyncIcon className='animation-rotate' />
            {translation.RespostaPautaModal.loading}
          </Typography>
        )
      }
      genericProps={{
        maxWidth: 'sm',
        DialogContentProps: {
          className: classes.root,
        },
        onClose: toClose,
      }}
    />
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(RespostaPautaModal);
